import axios from 'axios';
import Auth from '@/api/auth';
import base64 from 'base-64';
import queryString from 'query-string';
import Config from '@/config';
import dayjs from 'dayjs';
import * as Filters from '@/global/filters';

export const Token = {
  conciergeId: localStorage.conciergeId,

  /**
   * Retrieve stored token from session storage
   */
  getStoredToken: function() {
    return JSON.parse(localStorage.token || null);
  },

  /**
   * Save the token to session storage
   */
  storeToken: function(token) {
    localStorage.token = JSON.stringify(token);
  },

  /**
   * Get processed headers
   * with authorization credential included
   */
  getHeaders: function() {
    const { APIUsername: username, APIPassword: password } = Config;
    const credential = base64.encode(`${username}:${password}`);
    return {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Basic ${credential}`
    };
  },

  /**
   * Used to get the bearer token based on the userId
   * @param {string} userId with 00000, it can means an anonym token
   */
  getOauthToken: async function(userId = '00000') {
    const url = `${Config.BaseAPI}/v3/oauth/token`;
    const headers = this.getHeaders();

    const payload = {
      userId,
      grant_type: 'client_credentials',
      scope: 'flight'
    };
    const body = queryString.stringify(payload);
    const result = await axios.post(url, body, { headers });

    return result.data;
  },

  pingTabikoApi: async function(token) {
    const url = `${Config.BaseAPI}/v3/agent/${Config.TabikoBotConciergeId}`;

    const headers = {
      Authorization: `Bearer ${token.access_token}`,
      'Content-Type': 'application/json'
    };

    let result = false;

    let tokenExpiration = Filters.formatToUtcTimestamp(token.expirationDate);
    let currentUTC = Filters.formatToUtcTimestamp(dayjs());
    if (tokenExpiration < currentUTC) {
      return result;
    }

    try {
      const response = await axios.get(url, { headers });
      if (response.status == '200') {
        result = true;
      }
    } catch (error) {
      // Need this even though it does nothing.
      // If not there, error is not handles and function won't return false
    }

    return result;
  },

  /**
   * Retrieve the token from session storage
   * if there is no token exist, request one
   */
  getToken: async function() {
    const conciergeId = this.getConciergeId();

    if (!conciergeId) {
      /** TODO:
       * Bring in api/auth and logout in future
       * This way you'll have fresh chance to store conciergeId in localStorage
       */
      Auth.logoutConcierge(); // TODO: replace firebase logout with tabiko api logout in future
      throw new Error('Please set the conciergeId');
    }

    const storedToken = this.getStoredToken();
    if (storedToken) {
      const isValidToken = await this.pingTabikoApi(storedToken);
      if (isValidToken) {
        return storedToken.access_token;
      }
    }
    const token = await this.getOauthToken(conciergeId);
    this.storeToken(token);
    return token.access_token;
  },

  setConciergeId: function(conciergeId) {
    localStorage.conciergeId = conciergeId;
  },

  setConciergeSession: function(session) {
    localStorage.session = JSON.stringify(session);
  },

  getConciergeSession: function() {
    return JSON.parse(localStorage.session || null);
  },

  getConciergeId: function() {
    return localStorage.conciergeId;
  }
};
